var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 14.3996C11.5346 14.3996 14.4 11.5342 14.4 7.99961C14.4 4.46499 11.5346 1.59961 7.99998 1.59961C4.46535 1.59961 1.59998 4.46499 1.59998 7.99961C1.59998 11.5342 4.46535 14.3996 7.99998 14.3996ZM7.35707 4.99732C7.35707 4.64385 7.64361 4.35732 7.99707 4.35732H8.00475C8.35822 4.35732 8.64475 4.64385 8.64475 4.99732C8.64475 5.35078 8.35822 5.63732 8.00475 5.63732H7.99707C7.64361 5.63732 7.35707 5.35078 7.35707 4.99732ZM7.9952 11.6419C7.64174 11.6419 7.3552 11.3554 7.3552 11.0019L7.3552 7.13701C7.3552 6.78355 7.64174 6.49701 7.9952 6.49701C8.34866 6.49701 8.6352 6.78355 8.6352 7.13701L8.6352 11.0019C8.6352 11.3554 8.34866 11.6419 7.9952 11.6419Z",
    fill: "#8993A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconFilled);
export default __webpack_public_path__ + "static/media/info-icon-filled.9cef7d94c16ba63324c7fa0a0389f13b.svg";
export { ForwardRef as ReactComponent };